import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Eye } from 'lucide-react';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/2bZFL7e2w7n9QGDDvHAuay/Diseno_sin_titulo-51.png',
  alt: 'Ejemplos concretos para trabajar en el aula'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oAcrAByDxegKWTSwogxnGk/Diseno_sin_titulo-52.png',
  alt: 'Actividad práctica: Análisis de situaciones reales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ox2MBK4CWS9sySY2vpnoBd/Diseno_sin_titulo-53.png',
  alt: 'Clase 22: ¿Qué es participar políticamente?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4DQg9KM3gzhuFQc15ns42N/Diseno_sin_titulo-54.png',
  alt: 'Clase 24: Medios de comunicación y política'
}];
export function PreviewCarouselSection() {
  const [current, setCurrent] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % previewImages.length);
  }, []);
  const prev = useCallback(() => {
    setCurrent(prev => (prev - 1 + previewImages.length) % previewImages.length);
  }, []);
  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);
  const handleManualNav = (action: () => void) => {
    setIsAutoPlaying(false);
    action();
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-127">
          <div className="inline-flex items-center gap-2 bg-[#1e3a5a] text-white px-5 py-2 rounded-full mb-4" data-id="element-128">
            <Eye className="w-4 h-4 text-[#d4a853]" data-id="element-129" />
            <span className="font-semibold text-sm" data-id="element-130">MIRÁ POR DENTRO</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] mb-2" data-id="element-131">
            Páginas reales del material
          </h2>
          <p className="text-gray-600" data-id="element-132">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-133">
          {/* Main Image - natural size */}
          <div className="relative overflow-hidden rounded-2xl shadow-xl bg-gray-50" data-id="element-134">
            <div className="relative flex items-center justify-center min-h-[300px]" data-id="element-135">
              {previewImages.map((img, index) => <img key={index} src={img.src} alt={img.alt} className={`w-full h-auto transition-all duration-500 ease-in-out ${index === current ? 'relative opacity-100' : 'absolute opacity-0 pointer-events-none'}`} data-id="element-136" />)}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button onClick={() => handleManualNav(prev)} className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[#1e3a5a] p-2 sm:p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10" aria-label="Anterior" data-id="element-137">
            <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-138" />
          </button>
          <button onClick={() => handleManualNav(next)} className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[#1e3a5a] p-2 sm:p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10" aria-label="Siguiente" data-id="element-139">
            <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-140" />
          </button>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-141">
            {previewImages.map((_, index) => <button key={index} onClick={() => handleManualNav(() => setCurrent(index))} className={`rounded-full transition-all duration-300 ${index === current ? 'w-8 h-3 bg-[#d4a853]' : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-142" />)}
          </div>
        </div>

        {/* Thumbnails - Desktop */}
        <div className="hidden sm:grid grid-cols-4 gap-3 mt-6" data-id="element-143">
          {previewImages.map((img, index) => <button key={index} onClick={() => handleManualNav(() => setCurrent(index))} className={`rounded-lg overflow-hidden border-2 transition-all duration-300 ${index === current ? 'border-[#d4a853] shadow-lg scale-105' : 'border-transparent opacity-60 hover:opacity-100'}`} data-id="element-144">
              <img src={img.src} alt={img.alt} className="w-full h-auto" data-id="element-145" />
            </button>)}
        </div>
      </div>
    </section>;
}